import { Input, Component } from '@angular/core';

@Component({
  selector: 'sx-entity-status',
  templateUrl: './EntityStatus.component.html',
})
export class EntityStatusComponent {
  @Input() progreso: any;

  getTrackingInfo() {
    const porcentaje = this.progreso ? this.progreso.porcentaje : -1;

    if (porcentaje === -1) {
      return {
        label: 'NUEVO',
        color: 'Yellow',
        icon: 'fa fa-plus-square'
      };
    }
    if (porcentaje >= 0 && porcentaje < 100) {
      return {
        label: 'EN_CURSO',
        color: 'Yellow',
        icon: 'fa fa-server'
      };
    }
    if (porcentaje === 100) {
      return {
        label: 'ACTIVE',
        color: '#28a745',
        icon: 'fa fa-check-circle'
      };
    }
  }

  getTrackIcon() { }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/entityStatus.component.ts